import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StorageKeys } from 'src/app/shared-module-files/simpo.constant';

@Injectable({
  providedIn: 'root'
})
export class StaffServiceService {

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private snackbar: MatSnackBar,
  ) { }

  openServiceDialog(componentName: any, height: any, width: any, maxWidth: any, dataModel: any, position: any = { right: '0px', top: '0px' }) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth: maxWidth,
      data: dataModel,
      disableClose: true,
      position: position,
    });
  }
  openDialog(componentName: any, height: any, width: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
    });
  }

  openFilterDialog(componentName: any, height: any, width: any, dataModel: any, maxWidth: string = '95vw', maxHeight: string = '80vh') {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: false,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    });
  }

  openSocialBrand(componentName: any, height: any, width: any, data: any) {
    return this.dialog.open(componentName, {
      height: height,
      width: width,
      data: data,

    });
  }
  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 5000 });
  }

  createStaff(data: any) {
    return this.http.post(
      environment.baseUrl + `staff/staff`, data
    )
  }
  v2CreateStaff(data: any) {
    return this.http.post(
      environment.baseUrl + `staff/staff/create`, data
    )
  }


  updateStaff(staffId: any, data: any) {
    return this.http.put(
      environment.baseUrl + `staff/staff/update/extra-details?staffId=${staffId}`, data
    )
  }
  updateStaffDoc(data: any) {
    return this.http.put(
      environment.baseUrl + `staff/staff/update-docs`, data
    )
  }
  exportExcel(businessId: any) {
    return this.http.get(
      `${environment.baseUrl}staff/staff/export/staff?businessId=${businessId}`,
      { responseType: 'blob' }  // Important: specify blob for file download
    );
  }
  getStaffListing(businessId: any, pageNo: number, size: number, status: any, department?: any) {
    let url = `${environment.baseUrl}staff/staff/list/${businessId}?page=${pageNo}&size=${size}&status=${status}&isPagination=true`;

    // Add department only if it's not null, undefined, or empty string
    if (department) {
      url += `&department=${department}`;
    }

    return this.http.get(url);
  }

  getStaffListingforInvoice(businessId: any, pageNo: number, size: number, status: any, isPagination: boolean, department?: any) {
    let url = `${environment.baseUrl}staff/staff/list/${businessId}?page=${pageNo}&size=${size}&status=${status}&isPagination=${isPagination}`;

    // Add department only if it's not null, undefined, or empty string
    if (department) {
      url += `&department=${department}`;
    }

    return this.http.get(url);
  }

  getStaffBusinessDataByBusinessId(businessId) {
    return this.http.get(
      environment.baseUrl + `staff/staff/dashboard?businessId=${businessId}`
    )
  }


  getStaffDashboardData(
    businessId: any,
    startDate?: any,
    endDate?: any,
    department?: any
  ) {
    let url = `${environment.baseUrl}staff/staff/dashboard?businessId=${businessId}`;

    if (startDate && endDate) {
      url += `&startDate=${startDate}&endDate=${endDate}`;
    }

    if (department) {
      url += `&department=${department}`;
    }

    return this.http.get(url);
  }

getBusinessDetails(id:any){
     return this.http.get(
      environment.baseUrl + `business/v3/business?id=${id}`
    )
}
 getStaffBirthdayList(businessId: any) {
  let url = `${environment.baseUrl}staff/staff/birthday-list?businessId=${businessId}`;
  return this.http.get(url);
}

  getStaffDetailsById(Id: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/extra-details?staffId=${Id}`
    )
  }
  getAllStaffListing(businessId: any, pageNo: number, size: number, status: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/list/${businessId}?page=${pageNo}&size=${size}&status=${status}&isPagination=false`
    )
  }

  getStaffLogs(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/logs/activity/filter`, data
    )
  }
  getAllRoles(pageNo, size, businessId, data) {
    return this.http.get(
      environment.baseUrl + `staff/role/filter?pageNo=${pageNo}&pageSize=${size}&businessId=${businessId}`, data
    )
  }
  getLeadsListing(businessId: any, searchText: any) {
    let url = "";
    if (searchText) {
      url = url = url + `&searchText=${searchText}`
    } else {
      url = ""
    }
    return this.http.get(
      environment.baseUrl + `crm/leads/list?businessId=${businessId}${url}`
    )
  }

  getStaffListingByStaffName(businessId: any, pageNo: number, size: number, status: any, searchText: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/list/${businessId}?page=${pageNo}&size=${size}&status=${status}&searchText=${searchText}`
    )
  }

  getStaffPermissionByStaffId(staffId: any, businessId: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/get/permission?staffId=${staffId}&businessId=${businessId}`
    )
  }
  staffFilter(pageNo: any, size: any, data: any) {
    return this.http.put(
      environment.baseUrl + `staff/staff/filter?page=${pageNo}&size=${size}`, data
    )
  }

  deleteStaff(staffId: any, businessId: any) {
    return this.http.delete(
      environment.baseUrl + `staff/staff/inactivate/${staffId}?businessId=${businessId}`
    )
  }

  getStaffDetailsByStaffId(staffId: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/${staffId}`
    )
  }

  changeToggleStaff(data: any, staffId: any, status: any) {
    return this.http.put(
      environment.baseUrl + `staff/staff/status/${staffId}?status=${status}`, data
    )
  }

  getClassTeachers(payload) {
    return this.http.get(
      environment.baseUrl + `crm/allocation/grade-wise/staff?gradeId=${payload.gradeId}&sectionId=${payload.sectionId}&businessId=${localStorage.getItem('businessId')}`
    )
  }

  AssignRemoveStaff(businessId: any, data: any) {
    return this.http.put(
      environment.baseUrl + `staff/staff/${businessId}/assign-remove-staff`, data
    )
  }

  getAssignStaffListing(businessId: any, pageNo: number, size: number, searchText: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/${businessId}/auto-enquiry-enabled/list?pageNo=${pageNo}&size=${size}&searchText=${searchText}`
    )
  }

  //Staff Allocation:
  getStaffForAllocation(payload: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/list/${payload.businessId}?page=${payload.page}&size=${payload.size}&isPagination=${payload.isPagination}`
    )
  }
  getStaffList(payload: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/list/${payload.businessId}?page=${payload.page}&size=${payload.size}&isPagination=${payload.isPagination}&status=${payload.status}`
    )
  }
  getStaffByDesignation(payload: any) {
    return this.http.get(
      environment.baseUrl + `crm/role/designation/staff?businessId=${payload.businessId}&designation=${payload.designation}`, {}
    )
  }
  // for assign the staff
  assignStaff(data: any) {
    return this.http.post(
      environment.baseUrl + `staff/permission/assign`, data
    )
  }
  getStaffPermission(subModule?: any, access?: 'VIEW' | 'EDIT' | 'CREATE' | 'DELETE', module?: any) {

    let permission = JSON.parse(String(localStorage.getItem(StorageKeys.PERMISSIONS)));

    if (access) {
      if (
        permission?.admin ||
        (permission?.cmisPermission?.[module]?.[subModule] && permission.cmisPermission?.[module]?.[subModule].includes(access))
      )
        return true
    }

    if (!access) {
      if (permission?.admin ||
        (permission?.cmisPermission?.[module]?.[subModule] && permission?.cmisPermission?.[module]?.[subModule].length > 0)
      )
        return true;
    }
    return false;
  }

  // Your existing function
  getKDPermissionAPI(businessId: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/${businessId}/kit-distribution/list`
    );
  }

  getKDPermissions(
    businessId: string,
    subModule: string,
    loggedInStaffId: string,
    access?: 'VIEW' | 'EDIT' | 'CREATE' | 'DELETE'
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.getKDPermissionAPI(businessId).subscribe({
        next: (res: any) => {
          const staffList = res?.data;
          if (!Array.isArray(staffList)) {
            resolve(false);
            return;
          }

          const staff = staffList.find((s: any) => s.id === loggedInStaffId);
          if (!staff) {

            resolve(false);
            return;
          }

          if (staff.admin) {
            resolve(true);
            return;
          }

          const modulePerms = staff.modulePermission?.[subModule];

          if (access) {
            resolve(modulePerms?.includes(access) ?? false);
          } else {
            resolve(Array.isArray(modulePerms) && modulePerms.length > 0);
          }
        },
        error: (err) => {
          console.error('Error fetching staff permissions:', err);
          reject(false);
        }
      });
    });
  }




  showSidePanel() {
    let permission = JSON.parse(String(localStorage.getItem(StorageKeys.PERMISSIONS)));
    let response = {};
    if (permission.cmisPermission != null) {
      // for (let module of Object.keys(permission?.cmisPermission)) {
      //   if (!response[module])
      //     response[module] = {};

      //   let overAll: boolean = false;

      //   for (let subModule of Object.keys(permission.cmisPermission[module])) {
      // if (permission.admin) {
      //   response[module][subModule] = true;
      //   overAll = true;
      //   continue;
      // }

      //     if ((permission?.cmisPermission?.[module]?.[subModule]?.length || 0) > 0) {
      //       response[module][subModule] = true;
      //       overAll = true;
      //     }
      // else {
      //   response[module][subModule] = false;
      // }
      //   }

      //   if (permission.admin)
      //     response[module]['APP_SETTING'] = true;
      //   else
      //     response[module]['APP_SETTING'] = false;

      //   response[module]['show'] = overAll;
      // }
      Object.keys(permission.cmisPermission).forEach((module: any) => {
        if (!response[module]) response[module] = {};
        let overAll = false;
        Object.keys(permission.cmisPermission[module]).forEach((subModule: any) => {
          if (!response[module][subModule]) response[module][subModule] = {};

          if (permission.cmisPermission[module]?.[subModule]?.length > 0) {
            response[module][subModule] = true;
            overAll = true;
          }
          else {
            response[module][subModule] = false;
          }
        });
        response[module]['show'] = overAll;
      });

    }
    return response;
  }

  isStaffAdmin() {
    let permission = JSON.parse(String(localStorage.getItem(StorageKeys.PERMISSIONS)));
    return permission.admin;
  }

  //Staff Leave Requests Esacalations
  getticketEscalationList(payload) {
    let url = environment.baseUrl + `crm/master/staff-leave/${payload.businessId}/filter`;
    let queryParams: string[] = [];

    if (payload.pageNo !== undefined) {
      queryParams.push(`pageNo=${payload.pageNo}`);
    }
    if (payload.size !== undefined) {
      queryParams.push(`size=${payload.size}`);
    }
    if (payload.searchText) {
      queryParams.push(`searchText=${payload.searchText}`);
    }

    if (queryParams.length) {
      url += '?' + queryParams.join('&');
    }

    return this.http.get(url);
  }

  createLeaveRequestEscalation(payload: any) {
    return this.http.post(
      environment.baseUrl + `crm/master/staff-leave/create`, payload
    )
  }
  updateLeaveRequestEscalation(payload: any) {
    return this.http.put(
      environment.baseUrl + `crm/master/staff-leave/update`, payload
    )
  }

  deleteEscalation(id) {
    return this.http.delete(
      environment.baseUrl + `crm/master/staff-leave/delete?escalationId=${id}`,
    )
  }

  getStaffByDepartmentId(businessId, departmentId) {
    return this.http.get(
      environment.baseUrl + `crm//role/designation/staff?businessId=${businessId}&department=${departmentId}`,
    )
  }

  getAllDocumentTypes(data) {
    return this.http.put(
      environment.baseUrl + `crm/master/document-group/get-all`, data
    )
  }
  getAllDocumentGroups(category, data) {
    return this.http.put(
      environment.baseUrl + `crm/master/document-group/get-all?category=${category}`, data
    )
  }
  createDocType(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/master/document-group`, data
    )
  }
  updateDocType(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/master/document-group/update`, data
    )
  }
  deleteDocGroup(id) {
    return this.http.delete(
      environment.baseUrl + `crm/master/document-group/delete?id=${id}`
    )
  }
  //leaveReq apis
  getAllStaffLeaveReqs(businessId: any, pageNo?: number, size?: number, startDate?: string, endDate?: string) {
    let url = environment.baseUrl + `crm/leave/staff/list?businessId=${businessId}`;

    if (pageNo !== undefined && size !== undefined) {
      url += `&pageNo=${pageNo}&size=${size}`;
    }

    if (startDate && startDate !== '') {
      url += `&startDate=${startDate}`;
    }

    if (endDate && endDate !== '') {
      url += `&endDate=${endDate}`;
    }

    return this.http.get(url);
  }

  getLeaveTypes() {
    return this.http.get(
      environment.baseUrl + `staff/staff/leave-types`
    )
  }

  changeStaffLeaveReqStatus(payload: any) {
    let url = environment.baseUrl + `crm/leave/status?id=${payload.id}&status=${payload.status}`;

    if (payload.remarks) {
      url += `&remarks=${encodeURIComponent(payload.remarks)}`;
    }

    return this.http.put(url, {});
  }
  markStaffAttendance(payload) {
    return this.http.put(
      environment.baseUrl + `staff/staff-attendance/mark`, payload
    )
  }

  getStaffAttendanceListing(payload) {
    return this.http.put(
      environment.baseUrl + `staff/staff-attendance/list`, payload
    )
  }

  getStaffAttendanceListingFilter(payload) {
    return this.http.put(
      environment.baseUrl + `staff/staff-attendance/filter`, payload
    )
  }

  getStaffAttendanceCalendar(payload) {
    return this.http.get(
      environment.baseUrl + `staff/staff-attendance/calendar?businessId=${payload.businessId}&staffId=${payload.staffId}&year=${payload.year}&month=${payload.month}`
    )
  }

  getStaffById(staffId: any) {
    return this.http.get(
      environment.baseUrl + `staff/staff/${staffId}`
    );
  }
  getAllPendingApprovals(bId:any,pageNo:any,size:any) {
    return this.http.get(
      environment.baseUrl + `crm/registration/pending-approvals?businessId=${bId}&page=${pageNo}&size=${size}`
    );
  }
}

